module.exports = __webpack_public_path__ + "static/media/Groundskeeper Willie.9916ec62.png";